import { defineComponent as _defineComponent } from 'vue'
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import { useGetComponentName } from '~/composables/useGetComponentName';
import BlockBlockListStandard from '~/components/cms/custom/BlockBlockList/BlockBlockListStandard.vue';

import type { ConfigDisplayOptions } from '@az/middleware/src/__generated__/gql/graphql';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockBlockList',
  props: {
    title: null,
    contents: { default: () => [] },
    displayOptions: { default: () => [] },
    catchphrase: null,
    isContentExpanded: { type: Boolean },
    isPageAdvice: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { title?: string, contents: unknown[], displayOptions: ConfigDisplayOptions[], catchphrase?: string, isContentExpanded?: boolean, isPageAdvice?: boolean };

const BlockBlockListIdentityCard = () =>
  import('~/components/cms/custom/BlockBlockList/BlockBlockListIdentityCard.vue');
const BlockBlockListOverlay = () => import('~/components/cms/custom/BlockBlockList/BlockBlockListOverlay.vue');



const classes = useGetDisplayOptionsClasses(props.displayOptions);
const componentName = useGetComponentName(
  {
    'standard': BlockBlockListStandard,
    'identity-card': BlockBlockListIdentityCard,
    'green-clickable-block-list': BlockBlockListOverlay,
  },
  props.displayOptions,
);

return { __sfc: true,BlockBlockListIdentityCard, BlockBlockListOverlay, props, classes, componentName }
}

})